import React from 'react';
import { FileText, UserCheck, CreditCard, Package } from 'lucide-react';
import { howToOrderData } from '../data/mock';

const iconMap = {
  FileText,
  UserCheck,
  CreditCard,
  Package
};

const HowToOrder = () => {
  return (
    <section id="order" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
            {howToOrderData.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {howToOrderData.subtitle}
          </p>
        </div>

        {/* Steps */}
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
            {howToOrderData.steps.map((step, index) => {
              const Icon = iconMap[step.icon];
              return (
                <div key={index} className="relative">
                  {/* Connector Line */}
                  {index < howToOrderData.steps.length - 1 && (
                    <div className="hidden lg:block absolute top-16 left-1/2 w-full h-1 bg-gradient-to-r from-red-600 to-red-300 z-0"></div>
                  )}

                  {/* Step Card */}
                  <div className="relative bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-200 z-10">
                    {/* Step Number */}
                    <div className="absolute -top-4 -right-4 w-12 h-12 bg-gradient-to-br from-red-600 to-red-700 text-white rounded-full flex items-center justify-center font-bold text-lg shadow-lg">
                      {step.number}
                    </div>

                    {/* Icon */}
                    <div className="w-16 h-16 bg-gradient-to-br from-red-50 to-red-100 rounded-lg flex items-center justify-center mb-6">
                      <Icon className="w-8 h-8 text-red-600" />
                    </div>

                    {/* Content */}
                    <h3 className="text-xl font-bold text-gray-900 mb-3">
                      {step.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Visual Timeline for Mobile */}
          <div className="lg:hidden flex flex-col items-center space-y-4 mb-16">
            {howToOrderData.steps.map((_, index) => (
              index < howToOrderData.steps.length - 1 && (
                <div key={index} className="w-1 h-8 bg-gradient-to-b from-red-600 to-red-300"></div>
              )
            ))}
          </div>

          {/* Bottom Image Section */}
          <div className="bg-gradient-to-br from-red-50 to-white rounded-2xl overflow-hidden shadow-xl border border-red-100">
            <div className="grid md:grid-cols-2">
              <div className="p-12 space-y-6 flex flex-col justify-center">
                <h3 className="text-3xl font-bold text-gray-900">
                  Fast & Secure Delivery
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  We use express air shipping to ensure your medications reach you quickly and safely. 
                  All packages are discreetly packed and fully insured. Track your order in real-time 
                  from our facility to your doorstep.
                </p>
                <div className="space-y-3">
                  <div className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-red-600 rounded-full"></div>
                    <p className="text-gray-700">Express air shipping to 30+ countries</p>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-red-600 rounded-full"></div>
                    <p className="text-gray-700">Discreet and secure packaging</p>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-red-600 rounded-full"></div>
                    <p className="text-gray-700">Real-time tracking available</p>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-red-600 rounded-full"></div>
                    <p className="text-gray-700">Fully insured shipments</p>
                  </div>
                </div>
              </div>
              <div className="h-64 md:h-auto">
                <img
                  src={howToOrderData.image}
                  alt="Express Delivery"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowToOrder;
